import {db} from "@/main";
import {doc, getDoc, FirestoreDataConverter, setDoc, collection, getDocs, query} from "firebase/firestore";
import {v4 as uuidv4} from "uuid";

const userDataConverter: FirestoreDataConverter<UserData> = {
    toFirestore(data: UserData) {
        return data; 
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        const date = data?.lastLogin || null
        if (date == null) {
            return {
                ...data,
            } as UserData
        }
        return {
            ...data,
            lastLogin: date.toDate(),
        } as UserData;
    }
};

export function GetUserDatas(): Promise<UserData[]> {
    return new Promise<UserData[]>(async (resolve, reject) => {
        try {
            const userDataRef = collection(db, "userData").withConverter(userDataConverter);
            const userData: UserData[] = [];

            getDocs(userDataRef)
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        userData.push(doc.data());
                    });
                    resolve(userData);
                })
                .catch((error) => {
                    reject(`Error fetching userDatas: ${error}`);
                });

        } catch (error) {
            reject(error);
        }
    })}


export function GetUserData(userId: string): Promise<UserData> {
    return new Promise<UserData>((resolve, reject) => {
        const docRef = doc(db, "userData", userId).withConverter(userDataConverter);
        getDoc(docRef)
            .then((doc) => {
                if (doc.exists()) {
                    resolve(doc.data() as UserData);
                } else {
                    reject("No such document!");
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export async function GetUserDataEmplno(emplno: string): Promise<UserData> {
    return new Promise<UserData>(async (resolve, reject) => {

        const userDataRef = collection(db, "userData").withConverter(userDataConverter);

        const userDataQuery = query(
            userDataRef
        );

        const querySnapshot =  await getDocs(userDataQuery);
        const results = querySnapshot.docs.map(doc => doc.data());

        const filteredResults = results.filter(user => user.emplno?.toLowerCase() === emplno?.toLowerCase());

        if(filteredResults.length > 0) {
            resolve(filteredResults[0] as UserData);
        }
        else
        {
            reject("No such document!");
        }
    });
}

export async function GetUserDataByEmail(email: string): Promise<UserData> {
    return new Promise<UserData>(async (resolve, reject) => {

        const userDataRef = collection(db, "userData").withConverter(userDataConverter);

        const userDataQuery = query(
            userDataRef
        );

        const querySnapshot =  await getDocs(userDataQuery);
        const results = querySnapshot.docs.map(doc => doc.data());

        const filteredResults = results.filter(user => user.email?.toLowerCase() === email?.toLowerCase());

        if(filteredResults.length > 0) {
            resolve(filteredResults[0] as UserData);
        }
        else
        {
            reject("No such document!");
        }
    });
}

export async function GetUserDataByAdacount(adacount: string): Promise<UserData> {
    return new Promise<UserData>(async (resolve, reject) => {

        const userDataRef = collection(db, "userData").withConverter(userDataConverter);

        const userDataQuery = query(
            userDataRef
        );

        const querySnapshot =  await getDocs(userDataQuery);
        const results = querySnapshot.docs.map(doc => doc.data());

        const filteredResults = results.filter(user => user.adacount?.toLowerCase() === adacount?.toLowerCase());

        if(filteredResults.length > 0) {
            console.log("Filterresult", filteredResults)
            resolve(filteredResults[0] as UserData);
        }
        else
        {
            reject("No such document!");
        }
    });
}

export function SetUserData(userData: UserData): Promise<void> {
    return setDoc(doc(db, "userData", userData.sub.toString()), userData, { merge: true });
}

export function SetLoginData(user: any): Promise<void>{
    return setDoc(doc(db, "loginData", uuidv4().toString()), user, { merge: true });
}
